import {useTranslation} from 'react-i18next'
import type {ManualSeccion} from '@/manual'
import {cn} from '@/lib/utils'

/** Also the replay's chapter list. The screen-help sheet (`AyudaDePantalla`, U16) has no
 * player, so it omits `active`/`onSelect`/`cardRef`. */
export function StepCard({
  op,
  index,
  active = false,
  onSelect = null,
  cardRef,
}: {
  op: ManualSeccion['operaciones'][number]
  index: number
  active?: boolean
  onSelect?: (() => void) | null
  cardRef?: (el: HTMLDivElement | null) => void
}) {
  const {t} = useTranslation()
  return (
    <div
      ref={cardRef}
      role={onSelect ? 'button' : undefined}
      tabIndex={onSelect ? 0 : undefined}
      onClick={onSelect ?? undefined}
      onKeyDown={
        onSelect
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onSelect()
              }
            }
          : undefined
      }
      data-testid={op.id ? `manual-step-${op.id}` : undefined}
      className={cn(
        'surface flex gap-4 rounded-xl p-5 motion-safe:transition-colors',
        onSelect && 'cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-ring/50',
        active && 'ring-2 ring-primary/60'
      )}>
      <span
        className={cn(
          'shrink-0 font-mono text-lg leading-none font-semibold',
          active ? 'text-primary' : 'text-muted-foreground/50'
        )}>
        {String(index + 1).padStart(2, '0')}
      </span>
      <div className="space-y-2">
        <h2 className="font-heading text-base text-foreground">{op.titulo}</h2>
        <p className="text-sm text-foreground">{op.como}</p>
        <p className="text-sm text-muted-foreground">
          <span className="font-medium text-foreground">{t('manual.whyItMatters')}: </span>
          {op.porQueImporta}
        </p>
      </div>
    </div>
  )
}
